module.exports = __webpack_public_path__ + "img/dianchi-80.cf6869fa.png";